import imageArwesSystem from "../../../../src/images/docs/arwes-system-@2x.jpg";
import imageSystemExtensibility from "../../../../src/images/docs/system-extensibility-@2x.jpg";
import { PageContentLayout } from "../../../../src/components/PageContentLayout";
import * as React from 'react';
export default {
  imageArwesSystem,
  imageSystemExtensibility,
  PageContentLayout,
  React
};